import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import { TimeInput } from 'components/UI/'
import './index.scss'

const SendModal = ({ setOpen, open, time, setTime }) => {
  const handleClose = () => setOpen(false)

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogContent className='wrapperDialogEmail'>
        <DialogContentText id='alert-dialog-description'>
          <TimeInput time={time} setTime={setTime} />
        </DialogContentText>
      </DialogContent>
      <DialogActions className='wrapperDialogEmailActions'>
        <Button onClick={handleClose} color='primary' className='btnCansel'>
          CANSEL
        </Button>
        <Button className='btnSend' onClick={handleClose} color='primary' autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SendModal
